/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shareScreenSetting.vue?vue&type=template&id=240032b6&scoped=true&"
import script from "./shareScreenSetting.vue?vue&type=script&lang=js&"
export * from "./shareScreenSetting.vue?vue&type=script&lang=js&"
import style0 from "./shareScreenSetting.vue?vue&type=style&index=0&id=240032b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240032b6",
  null
  
)

export default component.exports